import React from 'react'

interface Props {
  size?: string
}
export const LoadingIcon: React.FC<Props> = ({ size = '35' }) => (
  <svg width={size} height={size} viewBox="0 0 35 35">
    <g fill="#573D39" fillRule="evenodd">
      <path d="M17.5 9c-.825 0-1.5-.675-1.5-1.5v-6c0-.825.675-1.5 1.5-1.5S19 .675 19 1.5v6c0 .825-.675 1.5-1.5 1.5">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0.05s"
          dur="0.65s"
          repeatCount="indefinite"
        />
      </path>
      <path d="M21.75 10.139a1.505 1.505 0 01-.549-2.05l3-5.195a1.504 1.504 0 012.049-.55c.715.413.962 1.335.549 2.05l-3 5.196a1.505 1.505 0 01-2.049.549">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0.1s"
          dur="0.65s"
          repeatCount="indefinite"
        />
      </path>
      <path d="M24.861 13.25a1.505 1.505 0 01.55-2.049l5.195-3a1.505 1.505 0 012.05.549 1.505 1.505 0 01-.55 2.049l-5.196 3a1.505 1.505 0 01-2.049-.549">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0.15s"
          dur="0.65s"
          repeatCount="indefinite"
        />
      </path>
      <path d="M26 17.5c0-.825.675-1.5 1.5-1.5h6c.825 0 1.5.675 1.5 1.5s-.675 1.5-1.5 1.5h-6c-.825 0-1.5-.675-1.5-1.5">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0.2s"
          dur="0.65s"
          repeatCount="indefinite"
        />
      </path>
      <path d="M24.861 21.75a1.505 1.505 0 012.05-.549l5.195 3c.715.412.962 1.334.55 2.049a1.505 1.505 0 01-2.05.549l-5.196-3a1.505 1.505 0 01-.549-2.049">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0.25s"
          dur="0.65s"
          repeatCount="indefinite"
        />
      </path>
      <path d="M21.75 24.861a1.504 1.504 0 012.049.55l3 5.195a1.505 1.505 0 01-.549 2.05 1.504 1.504 0 01-2.049-.55l-3-5.196a1.504 1.504 0 01.549-2.049">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0.30s"
          dur="0.65s"
          repeatCount="indefinite"
        />
      </path>
      <path d="M17.5 26c.825 0 1.5.675 1.5 1.5v6c0 .825-.675 1.5-1.5 1.5s-1.5-.675-1.5-1.5v-6c0-.825.675-1.5 1.5-1.5">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0.35s"
          dur="0.65s"
          repeatCount="indefinite"
        />
      </path>
      <path d="M13.25 24.861c.714.413.961 1.335.549 2.05l-3 5.195a1.505 1.505 0 01-2.049.55 1.505 1.505 0 01-.549-2.05l3-5.196a1.505 1.505 0 012.049-.549">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0.40s"
          dur="0.65s"
          repeatCount="indefinite"
        />
      </path>
      <path d="M10.139 21.75a1.504 1.504 0 01-.55 2.049l-5.195 3a1.505 1.505 0 01-2.05-.549 1.504 1.504 0 01.55-2.049l5.196-3a1.504 1.504 0 012.049.549">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0.45s"
          dur="0.65s"
          repeatCount="indefinite"
        />
      </path>
      <path d="M9 17.5c0 .825-.675 1.5-1.5 1.5h-6C.675 19 0 18.325 0 17.5S.675 16 1.5 16h6c.825 0 1.5.675 1.5 1.5">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0.50s"
          dur="0.65s"
          repeatCount="indefinite"
        />
      </path>
      <path d="M10.139 13.25a1.506 1.506 0 01-2.05.549l-5.195-3a1.505 1.505 0 01-.55-2.049 1.505 1.505 0 012.05-.549l5.196 3c.714.412.961 1.335.549 2.049">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0.55s"
          dur="0.65s"
          repeatCount="indefinite"
        />
      </path>
      <path d="M13.25 10.139a1.505 1.505 0 01-2.049-.55l-3-5.195a1.505 1.505 0 01.549-2.05 1.505 1.505 0 012.049.55l3 5.196a1.505 1.505 0 01-.549 2.049">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0.6s"
          dur="0.65s"
          repeatCount="indefinite"
        />
      </path>
    </g>
  </svg>
)
